import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardMenuFlow = createSelector(wizzardState, (wizzard) => wizzard.itemsMenuFlow);
